import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BsWhatsapp } from "react-icons/bs";
import Footer from '../../components/Footer/Footer';
import BannerImage from "../../assets/PreSchoolBanner.jpeg";
import { MdSchool, MdGroups, MdMenuBook, MdPalette, MdLightbulb, MdFavorite, MdFormatQuote } from 'react-icons/md';
import HeadImage from "../../assets/janet.jpeg";
import axios from 'axios';
import { api_url } from '../../url';
import { RotatingLines } from 'react-loader-spinner';

// Activity collage images
import ActImg1  from "../../assets/preschool/preschool1.jpeg";
import ActImg2  from "../../assets/preschool/preschool2.jpeg";
import ActImg3  from "../../assets/preschool/preschool3.jpeg";
import ActImg4  from "../../assets/preschool/preschool4.jpeg";
import ActImg5  from "../../assets/preschool/preschool5.jpeg";
import ActImg6  from "../../assets/preschool/preschool6.jpeg";
import ActImg7  from "../../assets/preschool/preschool7.jpeg";
import ActImg8  from "../../assets/preschool/preschool8.jpeg";
import ActImg9  from "../../assets/preschool/preschool9.jpeg";
import ActImg10 from "../../assets/preschool/preschool10.jpeg";
import ActImg11 from "../../assets/preschool/preschool11.jpeg";
import ActImg12 from "../../assets/preschool/preschool12.jpeg";
import ActImg13 from "../../assets/preschool/preschool13.jpeg";
import ActImg14 from "../../assets/preschool/preschool14.jpeg";
import ActImg15 from "../../assets/preschool/preschool15.jpeg";
import ActImg16 from "../../assets/preschool/preschool16.jpeg";
import ActImg17 from "../../assets/preschool/preschool17.jpeg";
import ActImg18 from "../../assets/preschool/preschool18.jpeg";
import ActImg19 from "../../assets/preschool/preschool19.jpeg";
import ActImg20 from "../../assets/preschool/preschool20.jpeg";
import ActImg21 from "../../assets/preschool/preschool21.jpeg";
import ActImg22 from "../../assets/preschool/preschool22.jpeg";
import ActImg23 from "../../assets/preschool/preschool23.jpeg";
import ActImg24 from "../../assets/preschool/preschool24.jpeg";
import ActImg25 from "../../assets/preschool/preschool25.jpeg";

const PreSchool = () => {
    const location = useLocation();

    const [preschoolEvents, setPreschoolEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [bannerLoaded, setBannerLoaded] = useState(false);

    const getPreschoolEvents = async () => {
        setLoadingEvents(true);
        try {
            const response = await axios.get(`${api_url}website/upcoming-events/?school=Preschool`);
            setPreschoolEvents(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingEvents(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getPreschoolEvents();
    }, [location]);

    const ageGroups = [
        { name: "Creche", desc: "For our youngest learners beginning their school experience." },
        { name: "Playgroup and Daisy", desc: "Building early communication, motor, and social skills." },
        { name: "Foundation", desc: "Strengthening foundational literacy and numeracy." },
        { name: "Reception", desc: "Preparing learners confidently for primary school." }
    ];

    const learningAreas = [
        { icon: <MdMenuBook />, title: "Literacy & Language", desc: "Early literacy and language development." },
        { icon: <MdSchool />, title: "Numeracy", desc: "Numeracy skills and logical thinking." },
        { icon: <MdPalette />, title: "Creative Arts", desc: "Creative arts and expression." },
        { icon: <MdGroups />, title: "Social & Emotional", desc: "Personal, social, and emotional development." },
        { icon: <MdFavorite />, title: "Physical & Motor", desc: "Physical development and motor skills." },
        { icon: <MdLightbulb />, title: "Discovery", desc: "Environmental awareness and discovery." }
    ];

    return (
        <div className="font-sans text-gray-800">

            {/* Hero Section */}
            <div className="relative h-[50vh] lg:h-[70vh] w-full flex items-center justify-center overflow-hidden bg-[#021d53]">
                <img 
                    src={BannerImage} 
                    alt="Pre-School Banner" 
                    onLoad={() => setBannerLoaded(true)}
                    fetchpriority="high"
                    decoding="async"
                    className={`absolute inset-0 h-full w-full object-cover brightness-[0.6] transition-opacity duration-1000 ${bannerLoaded ? 'opacity-100' : 'opacity-0'}`}
                />
                <div className="relative z-10 text-center px-5 max-w-4xl">
                    <h1 className="text-4xl md:text-7xl font-black text-white mb-6 tracking-tight [text-shadow:_0_4px_12px_rgb(0_0_0_/_80%)]">Preschool</h1>
                    <p className="text-blue-50 text-xl font-medium max-w-2xl mx-auto leading-relaxed [text-shadow:_0_2px_8px_rgb(0_0_0_/_80%)]">
                        Nurturing excellence from the start with a warm, engaging space for young learners.
                    </p>
                </div>
            </div>
            <section className="py-20 px-5 md:px-20 lg:px-40 bg-white">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl md:text-4xl font-bold text-[#021d53] mb-8 text-center">Nurturing Excellence from the Start</h2>
                    <p className="text-lg leading-relaxed mb-6 text-center text-gray-600">
                        At Anell School of Excellence, we believe the early years shape a child’s confidence, curiosity, and love for learning. Our Preschool is a warm, engaging space where young learners begin their academic journey with joy and purpose. We see each child as capable and full of potential, and we are intentional about creating experiences that help them grow socially, emotionally, physically, and intellectually.
                    </p>
                </div>
            </section>

            {/* Head of Preschool Welcome Message */}
            <section className="py-16 px-5 md:px-20 lg:px-40 bg-[#f8f9fa] mb-5">
                <div className="max-w-5xl mx-auto">
                    {/* Section Label */}
                    <div className="flex items-center gap-4 mb-10">
                        <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                        <p className="text-[#ed3137] font-bold uppercase tracking-widest text-sm">Welcome Message from the Head of Preschool</p>
                        <div className="h-1 flex-1 bg-gray-200 rounded-full"></div>
                    </div>

                    {/* Responsive layout: image stacks on mobile, floats right on md+ */}
                    <div className="flex flex-col md:flex-row md:items-start gap-8">

                        {/* Image card – appears first on mobile, right-side on md+ */}
                        <div className="w-full md:w-64 lg:w-72 shrink-0 md:order-2">
                            <div className="relative">
                                <div className="absolute -top-3 -left-3 w-full h-full border-4 border-[#021d53] rounded-2xl"></div>
                                <img
                                    src={HeadImage}
                                    alt="Ms. Janet Gyamfi – Head of Preschool Department"
                                    className="relative w-full h-64 md:h-80 object-cover object-top rounded-2xl shadow-xl"
                                />
                                <div className="mt-4 bg-[#021d53] text-white rounded-xl px-4 py-3 text-center">
                                    <p className="font-bold text-sm leading-tight">Ms. Janet Gyamfi</p>
                                    <p className="text-[#ed3137] text-xs font-semibold mt-1 uppercase tracking-wide">Head of Preschool Department</p>
                                </div>
                            </div>
                        </div>

                        {/* Text content */}
                        <div className="flex-1 md:order-1">
                            {/* Opening quote icon */}
                            <MdFormatQuote className="text-6xl text-[#021d53]/10 -mb-4" />

                            <h2 className="text-2xl md:text-3xl font-extrabold text-[#021d53] mb-6 leading-snug">
                                Welcome to the Preschool Department of<br className="hidden md:block" /> Anell School of Excellence
                            </h2>

                            <div className="space-y-4 text-gray-600 leading-relaxed text-[15px]">
                                <p>
                                    It is a joy to welcome you and your child to a warm, nurturing, and stimulating environment where the foundation for lifelong learning is carefully laid. At our preschool, we believe that every child is unique, full of potential, and deserving of a safe and engaging space to grow, explore, and thrive.
                                </p>
                                <p>
                                    Our academic structure is thoughtfully designed to suit the developmental needs of our young learners. Through a blend of play-based and guided learning, we introduce children to key areas such as Numeracy, Phonics &amp; Literacy, Writing Skills, Creative Arts, Discovery, and Oral &amp; Auditory development. These learning experiences are carefully structured to build early cognitive skills, language development, and foundational concepts in a fun and meaningful way.
                                </p>
                                <p>
                                    Beyond academics, we are deeply committed to the holistic development of every child. We focus on nurturing social skills, emotional confidence, creativity, physical coordination, and positive communication. Through interactive activities, group play, music, movement, and hands-on exploration, our learners develop independence, curiosity, and a love for learning.
                                </p>
                                <p>
                                    Our dedicated facilitators provide individual attention and use child-centered approaches to ensure that each learner progresses at their own pace in a supportive and caring environment. We also value strong partnerships with parents, recognizing that collaboration between home and school is key to a child's success.
                                </p>
                                <p>
                                    At Anell School of Excellence, we are proud to create joyful early learning experiences that prepare our children not only for the next stage of education but for life.
                                </p>
                                <p className="font-semibold text-gray-700">
                                    We look forward to walking this exciting journey with you and your child.
                                </p>
                            </div>

                            {/* Signature */}
                            <div className="mt-8 pt-6 border-t border-gray-200">
                                <p className="font-bold text-[#021d53] text-lg">Ms. Janet Gyamfi</p>
                                <p className="text-[#ed3137] font-semibold text-sm uppercase tracking-widest mt-1">Head of Preschool Department</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <div className="grid xl:grid-cols-12 px-5 md:px-20 lg:px-40 gap-10">
                <div className="col-span-8">

                    {/* Introduction Section */}

                    {/* Philosophy Section */}
                    <section className="py-20 px-5 md:px-10 lg:px-20 bg-gray-50">
                        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-12">
                            <div className="md:w-1/2">
                                <h2 className="text-3xl font-bold text-[#021d53] mb-6">Our Early Childhood Philosophy</h2>
                                <p className="text-lg leading-relaxed text-gray-600 mb-4">
                                    Our philosophy is centered on nurturing the whole child. We focus on building strong foundations in character, communication, and confidence while encouraging curiosity and independence.
                                </p>
                                <p className="text-lg leading-relaxed text-gray-600">
                                    We believe children learn best when they feel safe, valued, and inspired. Through guided exploration and meaningful interaction, we help them develop resilience, empathy, and a positive attitude toward learning.
                                </p>
                            </div>
                            <div className="md:w-1/2 bg-[#021d53] p-10 rounded-3xl shadow-2xl text-white transform rotate-2">
                                <p className="text-2xl font-semibold italic">
                                    "Every child is guided to grow, explore, and shine."
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Age Groups Section */}
                    <section className="py-20 px-5 md:px-10 bg-white">
                        <div className="max-w-[1440px] mx-auto">
                            <div className="text-center mb-16">
                                <h2 className="text-3xl md:text-4xl font-bold text-[#021d53] mb-4">Age Groups and Class Levels</h2>
                                <p className="text-gray-600 max-w-2xl mx-auto">
                                    Our Preschool caters to children within the early childhood age range and is structured to support progressive development.
                                </p>
                            </div>
                            <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
                                {ageGroups.map((group, index) => (
                                    <div key={index} className="p-8 border-t-4 border-[#ed3137] bg-gray-50 rounded-b-xl shadow-sm hover:shadow-md transition-shadow">
                                        <h3 className="text-xl font-bold text-[#021d53] mb-3">{group.name}</h3>
                                        <p className="text-gray-600">{group.desc}</p>
                                    </div>
                                ))}
                            </div>
                            <p className="mt-12 text-center text-gray-600 italic">
                                Each level is thoughtfully designed to match developmental milestones while ensuring children move forward with confidence and readiness.
                            </p>
                        </div>
                    </section>

                    
                </div>
                <div className="col-span-4 mb-3">
                    <h2 className=' pb-5 text-2xl font-bold text-[#021d53] mb-4'>PRESCHOOL EVENTS</h2>
                    {loadingEvents ? (
                        <div className="flex items-center justify-center p-10 h-[180px]">
                            <RotatingLines
                                strokeColor="#021D53"
                                strokeWidth="5"
                                animationDuration="0.75"
                                width="40"
                                visible={true}
                            />
                        </div>
                    ) : (
                        <>
                            {preschoolEvents?.length > 0 ? (
                                preschoolEvents.map((event) => (
                                    <div key={event.id} className='flex gap-4 my-[15px] min-h-[140px] bg-gray-50'>
                                        <div className='flex flex-col items-center justify-center w-[30%] bg-[#021d53] text-white shrink-0'>
                                            <span className="text-3xl font-bold mb-1">{event.day}</span>
                                            <span className="text-xs uppercase">{event.month?.substring(0, 3)}</span>
                                        </div>
                                        <div className='py-6 px-4 flex flex-col justify-center text-sm'>
                                            <h4 className="text-xl font-bold mb-1 leading-tight">{event.title}</h4>
                                            <span className='text-gray-500 font-medium'>{event.time}</span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className='flex items-center justify-center h-[180px] bg-gray-50 text-gray-500 italic'>
                                    No upcoming events
                                </div>
                            )}
                        </>
                    )}
                    <div className="flex items-center justify-center mt-8">
                        <Link to="/news-events/calendar">
                            <button className="bg-transparent border border-[#021d53] text-[#021d53] px-12 py-3 font-bold text-lg hover:bg-[#021d53] hover:text-white transition-all uppercase tracking-widest shadow-lg hover:scale-105 active:scale-95">VIEW CALENDAR</button>
                        </Link>
                    </div>
                </div>
            </div>
            {/* Core Learning Areas */}
                    <section className="py-20 px-5 md:px-10 lg:px-20 bg-[#021d53] text-white">
                        <div className="max-w-[1440px] mx-auto">
                            <div className="text-center mb-16">
                                <h2 className="text-3xl md:text-4xl font-bold mb-4">Core Learning Areas</h2>
                                <p className="text-blue-100 max-w-2xl mx-auto">
                                    Our preschool curriculum provides a balanced blend of structured learning and guided play.
                                </p>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                                {learningAreas.map((area, index) => (
                                    <div key={index} className="flex gap-5 p-6 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/10 hover:bg-white/20 transition-all">
                                        <div className="text-4xl text-[#ed3137] shrink-0">
                                            {area.icon}
                                        </div>
                                        <div>
                                            <h4 className="text-xl font-bold mb-2">{area.title}</h4>
                                            <p className="text-blue-50 text-sm leading-relaxed">{area.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <p className="mt-12 text-center font-medium">
                                We intentionally integrate moral instruction and positive values into daily learning to shape responsible and respectful young learners.
                            </p>
                        </div>
                    </section>

                    {/* Approach Section */}
                    <section className="py-20 px-5 md:px-20 lg:px-40 bg-white">
                        <div className="max-w-4xl mx-auto space-y-12">
                            <div className="text-center">
                                <h2 className="text-3xl md:text-4xl font-bold text-[#021d53] mb-6">Teaching Approach and Environment</h2>
                                <p className="text-lg leading-relaxed text-gray-600">
                                    At Anell, learning is active and engaging. Our classrooms are vibrant, well-resourced spaces that encourage exploration and collaboration. We adopt a play-based and inquiry-driven approach, where children learn through hands-on activities, storytelling, music, movement, and guided discovery.
                                </p>
                            </div>
                            <div className="bg-[#f8f9fa] p-10 rounded-3xl border-l-8 border-[#ed3137]">
                                <p className="text-lg leading-relaxed text-gray-700">
                                    Our teachers provide individualized attention, understanding that every child develops at their own pace. Through observation and continuous assessment, we tailor support to meet each learner’s needs, ensuring steady and meaningful progress.
                                </p>
                            </div>
                            <p className="text-center text-lg text-gray-600">
                                Outdoor learning, interactive activities, and practical experiences are woven into our program to help children connect learning with the world around them.
                            </p>
                        </div>
                    </section>

                    {/* Holistic Development Section */}
                    <section className="py-20 px-5 md:px-10 lg:px-20 bg-gray-50">
                        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
                            <div>
                                <h2 className="text-3xl font-bold text-[#021d53] mb-6">Care, Creativity, and Holistic Development</h2>
                                <p className="text-lg leading-relaxed text-gray-600 mb-6">
                                    Beyond academics, we prioritize care and character formation. We foster a nurturing environment where children feel secure, respected, and confident to express themselves. Creativity is encouraged through art, music, drama, and imaginative play, allowing children to discover their talents and interests early.
                                </p>
                                <p className="text-lg leading-relaxed text-gray-600">
                                    We also value strong partnerships with parents, recognizing that collaboration between home and school strengthens a child’s growth. Together, we create a supportive foundation that prepares our learners not just for primary school, but for lifelong success.
                                </p>
                            </div>
                            <div className="flex flex-col gap-6">
                                <div className="bg-white p-8 rounded-2xl shadow-md border-b-4 border-[#021d53]">
                                    <h4 className="font-bold text-[#021d53] mb-2">Care & Character</h4>
                                    <p className="text-sm text-gray-600">Nurturing environment for secure growth.</p>
                                </div>
                                <div className="bg-white p-8 rounded-2xl shadow-md border-b-4 border-[#ed3137]">
                                    <h4 className="font-bold text-[#ed3137] mb-2">Parent Partnership</h4>
                                    <p className="text-sm text-gray-600">Strong collaboration for child growth.</p>
                                </div>
                            </div>
                        </div>
                    </section>

            {/* Preschool Activity Photo Collage */}
            <section className="py-20 px-5 md:px-20 lg:px-40 bg-white">
                <div className="max-w-6xl mx-auto">
                    {/* Section Header */}
                    <div className="text-center mb-12">
                        <div className="flex items-center justify-center gap-4 mb-4">
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                            <p className="text-[#ed3137] font-bold uppercase tracking-widest text-sm">Life at Preschool</p>
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                        </div>
                        <h2 className="text-3xl md:text-4xl font-extrabold text-[#021d53]">A Glimpse Into Our World</h2>
                        <p className="text-gray-500 mt-3 max-w-xl mx-auto text-sm">Every day is filled with joy, discovery, and growth. Here's a peek at the vibrant life of our little learners.</p>
                    </div>

                    {/* CSS Columns masonry — auto-balances any number of photos */}
                    <div className="columns-2 md:columns-3 lg:columns-4 gap-3">
                        {[
                            ActImg1,  ActImg2,  ActImg3,  ActImg4,  ActImg5,
                            ActImg6,  ActImg7,  ActImg8,  ActImg9,  ActImg10,
                            ActImg11, ActImg12, ActImg13, ActImg14, ActImg15,
                            ActImg16, ActImg17, ActImg18, ActImg19, ActImg20,
                            ActImg21, ActImg22, ActImg23, ActImg24, ActImg25,
                        ].map((src, i) => (
                            <div
                                key={i}
                                className="break-inside-avoid mb-3 overflow-hidden rounded-xl group cursor-pointer"
                            >
                                <img
                                    src={src}
                                    alt={`Preschool activity ${i + 1}`}
                                    className="w-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
            
            
        </div>
    );
};

export default PreSchool;
